import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import P from "components/P";
import ToolTip from "components/tooltip/tooltip";
import { t } from "i18next";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SingleAdminTable from "routes/admin/table/SingleAdminTable";
import TableSearchCard from "routes/table/search/TableSearchCard";
import style from "./ProductSalesStatistics.module.css";
import AdminImage from "components/Image/AdminImage";
import Inline from "layouts/container/Inline";

function ProductSalesStatistics() {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [limit, setLimit] = useState(20);
  const buttons = [];
  const extraCondition = { status: "product" };
  useEffect(() => {
    adminRequester.getStatistic(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.data);
      }
    );
  }, [page, searchCondition, limit]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getStatistic(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.data);
        }
      );
      setResearch(false);
    }
  }, [research]);

  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };

  const theader = [
    {
      width: 50,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
      index: "0",
    },
    {
      width: 100,
      text: "",
      code: "thumbnail",
      Cell: ({ cell }) => (
        <ToolTip
          style={{ zIndex: 10 }}
          title={<AdminImage src={cell} width={"30vh"} height={"30vh"} />}
        >
          <AdminImage src={cell} width={100} height={100} />
        </ToolTip>
      ),
    },
    {
      width: 100,
      text: "이름",
      code: "title",
      Cell: ({ cell }) => (
        <P ellipsis width="100px">
          {cell}
        </P>
      ),
    },
    {
      width: 100,
      text: "판매량",
      code: "count",
      Cell: ({ cell }) => Number(cell ? cell : 0).toLocaleString("ko-kr"),
    },
    {
      width: 100,
      text: "판매액",
      code: "total",
      Cell: ({ cell }) => Number(cell ? cell : 0).toLocaleString("ko-kr"),
    },
    {
      width: 400,
      text: "옵션별 판매량 및 판매액",
      code: "variants",
      Cell: ({ cell }) => (
        <VerticalFlex>
          {cell?.map((variant) => (
            <FlexChild key={variant.id}>
              <HorizontalFlex gap={10}>
                <FlexChild>
                  <Inline>
                    <P>{variant.title}</P>
                    <P> (</P>
                    <P color="red">
                      {Number(variant.count || 0)?.toLocaleString("ko-kr")}
                    </P>
                    <P>개)</P>
                  </Inline>
                </FlexChild>
                <FlexChild justifyContent="flex-end" width={"max-content"}>
                  <P>{Number(variant.total || 0)?.toLocaleString("ko-kr")}</P>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          ))}
        </VerticalFlex>
      ),
    },
  ];

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            <FlexChild width="max-content">
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontSize: 18,
                  paddingBottom: "8px",
                  fontWeight: "700",
                }}
              >
                {t("상품 통계")}
              </div>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={10}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            // output={out}
            page={page}
            buttons={buttons}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default ProductSalesStatistics;
